
// IndexedDB utility for storing application data
const DB_NAME = 'gncgo_db';
const DB_VERSION = 1;
const STORE_NAME = 'app_data';

let dbInstance = null;

const openDB = () => {
    return new Promise((resolve, reject) => {
        if (dbInstance) {
            resolve(dbInstance);
            return;
        }

        // Timeout after 5 seconds if IndexedDB doesn't respond
        const timeout = setTimeout(() => {
            reject(new Error('IndexedDB open timeout - may be blocked or unavailable'));
        }, 5000);

        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onerror = () => {
            clearTimeout(timeout);
            reject(new Error('Failed to open IndexedDB'));
        };

        request.onsuccess = (event) => {
            clearTimeout(timeout);
            dbInstance = event.target.result;
            resolve(dbInstance);
        };

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        };
    });
};

export const getItem = async (key) => {
    console.log("indexedDB is disabled")
    return
    
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            // Timeout after 3 seconds if transaction doesn't complete
            const timeout = setTimeout(() => {
                reject(new Error('IndexedDB getItem timeout'));
            }, 3000);

            const transaction = db.transaction([STORE_NAME], 'readonly');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.get(key);

            request.onsuccess = () => {
                clearTimeout(timeout);
                resolve(request.result);
            };

            request.onerror = () => {
                clearTimeout(timeout);
                reject(new Error('Failed to get item from IndexedDB'));
            };
        });
    } catch (error) {
        console.error('IndexedDB getItem error:', error);
        return null;
    }
};

export const setItem = async (key, value) => {
    console.log("indexedDB is disabled")
    return
    
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            // Timeout after 3 seconds if transaction doesn't complete
            const timeout = setTimeout(() => {
                reject(new Error('IndexedDB setItem timeout'));
            }, 3000);

            const transaction = db.transaction([STORE_NAME], 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.put(value, key);

            request.onsuccess = () => {
                clearTimeout(timeout);
                resolve();
            };

            request.onerror = () => {
                clearTimeout(timeout);
                reject(new Error('Failed to set item in IndexedDB'));
            };
        });
    } catch (error) {
        console.error('IndexedDB setItem error:', error);
        throw error;
    }
};

export const removeItem = async (key) => {
    console.log("indexedDB is disabled")
    return
    
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([STORE_NAME], 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.delete(key);

            request.onsuccess = () => {
                resolve();
            };

            request.onerror = () => {
                reject(new Error('Failed to remove item from IndexedDB'));
            };
        });
    } catch (error) {
        console.error('IndexedDB removeItem error:', error);
        throw error;
    }
};
